export const messages = {
  en: {
    orgCommunity: {
      title: 'Organization Community Management',
      orgName: 'Organization Name',
      orgId: 'Organization ID',
      shopName: 'Shop Name',
      shopId: 'Shop ID',
      shopAddress: 'Shop Address',
      operations: 'Operations',
      deleteConfirm: 'Confirm to delete the affiliated shop?',
      addSuccess: 'Add successfully',
      deleteSuccess: 'Delete successfully',
      selectShopTip: 'Please select at least one shop',
      back: 'Back',
      add: 'Add',
      delete: 'Delete',
      cancel: 'Cancel',
      confirm: 'Confirm',
      searchPlaceholder: 'Input shop name'
    }
  },
  zh: {
    orgCommunity: {
      title: '组织隶属店铺管理',
      orgName: '组织名称',
      orgId: '组织ID',
      shopName: '店铺名称',
      shopId: '店铺ID',
      shopAddress: '店铺地址',
      operations: '操作',
      deleteConfirm: '确定删除隶属店铺?',
      addSuccess: '添加成功',
      deleteSuccess: '删除成功',
      selectShopTip: '请至少选择一家店铺',
      back: '返回',
      add: '添加',
      delete: '删除',
      cancel: '取消',
      confirm: '确认',
      searchPlaceholder: '输入店铺名称'
    }
  }
}